import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {EventBus} from "../../event/EventBus";
import {NavigationEvent} from "../../event/NavigationEvent";
import {filter} from "rxjs/operators";

@Injectable()
export class NavService {

    constructor(private router:Router, private eventBus:EventBus) {
      this.eventBus
            .pipe(filter(event => event.type === NavigationEvent.TYPE))
            .subscribe((event:NavigationEvent) => this.navigate(event.location, event.options));
    }

    public navigate(location:any[], extras?: any):Promise<boolean> {
        // TODO: This could enforce a list of app locations, rather than just delegating everything to router
      return this.router.navigate(location, extras);
    }

}
